<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $tc('moviecategory') }}</div>
      <router-link
        class="btn-blue"
        to="movie-categories"
      >{{ $tc('moviecategory') }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in MovieCategories"
          :key="index"
          v-if="item.fieldname !== 'mc_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'mc_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1)}}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && errors.has(item.fieldname)"
              >{{ errors.first(`${item.fieldname}`) }}</span>
            </p>
          </div>

          <div v-if="item.fieldname === 'mc_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t(item.label) }}</label>
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" v-model="item.fieldvalue" />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <!-- <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
                <input placeholder="." type="text" required="required" />
              <label>{{ $tc('moviecategory') }}</label>
            </div>
            <Tooltip :title="`'Movie category eg: Now showing, Coming Soon etc'`"  />
          </div>
          <p class="error_message">{{ $t('blankfieldmsg') }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div>
                <label class="ios-switch">
                  <input type="checkbox" class="ios-checkbox" checked />
                  <span class="switch-slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>-->

        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(false)"
          >{{ $t('saveaddmore') }}</button>
          <button class="btn-black" @click.prevent.stop="onResetForm">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="movie-categories"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";
import MovieCategories from "@/helper/formJSONMaster/MovieCategories";

export default {
  data() {
    return {
      btenable: false,
      MovieCategories: MovieCategories.ms_movie_categories,
      // v-validate="'required|email'"
      submitted: false,
      Methods: MovieCategories.Methods
    };
  },
  mounted() {
    this.onResetForm();
  },
  methods: {
    onFocusHandler: function() {
      // this.submitted = false;
    },
    onResetForm: function() {
      this.MovieCategories.map(x => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody(
            "POST",
            this.MovieCategories,
            this.Methods
          );
          MasterService.GlobalRequest(body)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/movie-categories"
                  });
                }
              } else {
                this.$toasted.show(data.message);
                console.log("show error1 :", data.message);
              }
            })
            .catch(error => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieCategoriesComponents/addMovieCategory.vue